"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bufferToSha1 = void 0;
const crypto = require("crypto");
const stream_1 = require("stream");
const types_1 = require("./types");
const HASH_ENCODING = "hex";
async function bufferToSha1(buffer) {
    const stream = stream_1.Readable.from(buffer);
    const hash = crypto.createHash(types_1.HashAlgorithm.Sha1);
    return new Promise((resolve, reject) => {
        stream
            .pipe(hash)
            .on("finish", () => {
            hash.end();
            const digest = hash.read().toString(HASH_ENCODING);
            resolve(digest);
        })
            .on("error", (err) => {
            reject(err);
        });
    });
}
exports.bufferToSha1 = bufferToSha1;
//# sourceMappingURL=buffer-utils.js.map